import { useQuery } from '@tanstack/react-query';

import { api } from '../api/client';

/** Wave 4b — poll ``GET /api/v1/series/prep/{batch_id}`` for the
 *  «готовлю N/M» card while an async-convergence batch is being built
 *  by the scheduler daemon.
 *
 *  5-second pulse: prep is short (fetch+slice+create per station, a
 *  handful of seconds each) and the operator is staring at the card
 *  waiting for it to clear, so a snappy interval matters more here than
 *  on the 30 s batches poll. Polling STOPS the moment ``status`` leaves
 *  ``PREPARING`` (``refetchInterval`` reads the last result and returns
 *  ``false``), so a DONE/PARTIAL batch costs exactly one final request.
 *
 *  ``enabled`` lets the Feed mount the hook unconditionally per card
 *  but pause it (e.g. an empty id) without violating hook order.
 */
export function useSeriesPrep(batchId: string, enabled = true) {
  return useQuery({
    queryKey: ['series-prep', batchId],
    queryFn: () => api.getPrepStatus(batchId),
    enabled: enabled && batchId.length > 0,
    refetchInterval: (query) =>
      query.state.data?.status === 'PREPARING' ? 5_000 : false,
    // A just-accepted batch may not have a daemon-claimed row yet; keep
    // the result fresh so the first poll fires immediately on mount.
    staleTime: 0,
  });
}
